module.exports = __webpack_public_path__ + "img/新乡市.f6644e54.png";